import CompanyClientImportContent from "../../features/companyClients/widgets/CompanyClientImportContent";

function CompanyClientImportScreen() {
  return <CompanyClientImportContent />;
}

export default CompanyClientImportScreen;
